// src/i18n.ts
import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import fr from './locales/fr.json'

// Define translations for English and French
const messages = {
  en,
  fr,
}

// Create the i18n instance
const i18n = createI18n({
  legacy: false,
  locale: 'en', // Set the default language
  fallbackLocale: 'en', // Set fallback language
  messages,
})

export default i18n
